import React, { useEffect, useState } from "react";
import SingleImageUpdate from "./SingleImageUpdate";
import EditImageUpdateCase from "./EditImageUpdateCase";

function ImageUpdate({
    editedImageIndex,
    setEditedImageIndex,
    removeImageName,
    setRemoveImagename,
    imagesToUpload,
    setImagesToUpload,
    toggleStates,
    setToggleStates,
}) {
    const [selectedImage, setSelectedImage] = useState([...imagesToUpload]);
    const [directUpload, setDirectUpload] = useState(false);

    useEffect(() => {
        setSelectedImage([...imagesToUpload]);
    }, [imagesToUpload]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeLimit = 5 * 1024 * 1024; // 5 MB
            const allowedFileTypes = ["image/jpeg", "image/png", "image/svg+xml"];

            if (file.size > fileSizeLimit) {
                alert("File size exceeds the limit of 5MB");
                return;
            }

            if (!allowedFileTypes.includes(file.type)) {
                alert("Invalid file type. Please select a JPG, PNG, or SVG file.");
                return;
            }

            const reader = new FileReader();

            reader.onload = () => {
                const img = new window.Image();
                img.onload = () => {
                    img.imageType = false;
                    setSelectedImage((prev) => {
                        const next = [...prev, img];
                        setImagesToUpload(next);
                        setEditedImageIndex(next.length - 1);
                        return next;
                    });
                    setDirectUpload(true);
                };
                img.src = reader.result;
            };
            reader.readAsDataURL(file);
            e.target.value = null;
        }
    };

    const handleCancelEdit = () => {
        if (editedImageIndex !== null && directUpload) {
            const updatedSelectedImage = [...selectedImage];
            updatedSelectedImage.splice(editedImageIndex, 1);
            setSelectedImage(updatedSelectedImage);
            setImagesToUpload(updatedSelectedImage);
            setEditedImageIndex(null);
            setDirectUpload(false);
            return;
        }
        setEditedImageIndex(null);
        setDirectUpload(false);
    };

    return (
        <div>
            <article className="widgetWrap uploadCaseWidget">
                <div className="widgetHeader">
                    <span>Case Images</span>
                </div>
                <div className="widgetBody">
                    {editedImageIndex == null &&
                        selectedImage &&
                        selectedImage.length > 0 && (
                            <ul className="listUnstyled uploadList">
                                {selectedImage.map((image, index) => (
                                    <SingleImageUpdate
                                        setEditedImageIndex={setEditedImageIndex}
                                        key={index}
                                        index={index}
                                        image={image}
                                        selectedImage={selectedImage}
                                        setSelectedImage={setSelectedImage}
                                        setRemoveImagename={setRemoveImagename}
                                        removeImageName={removeImageName}
                                        directUpload={directUpload}
                                        setDirectUpload={setDirectUpload}
                                        setImagesToUpload={setImagesToUpload}
                                        toggleStates={toggleStates}
                                        setToggleStates={setToggleStates}
                                    />
                                ))}
                            </ul>
                        )}
                    {editedImageIndex !== null && (
                        <EditImageUpdateCase
                            directUpload={directUpload}
                            setDirectUpload={setDirectUpload}
                            editedImageIndex={editedImageIndex}
                            setSelectedImage={setSelectedImage}
                            setImagesToUpload={setImagesToUpload}
                            selectedImage={selectedImage}
                            setEditedImageIndex={setEditedImageIndex}
                            image={selectedImage?.find((item, index) => {
                                return index === editedImageIndex;
                            })}
                        />
                    )}
                    {editedImageIndex === null && (
                        <div className="uploadBtnWrap">
                            <input
                                onChange={handleFileChange}
                                id="uploadImage"
                                type="file"
                                accept="image/jpeg,image/png,image/svg+xml"
                                className="srOnly"
                            />
                            <label htmlFor="uploadImage" className="label btn btnPrimary">
                                Upload Image <i className="icn fa-solid fa-x-ray"></i>
                            </label>
                        </div>
                    )}
                </div>
                {editedImageIndex !== null && (
                    <div className="widgetFooter">
                        <div className="textCenter">
                            <button type="button" className="btn btnSecondary" onClick={handleCancelEdit}>
                                {directUpload ? "Remove image" : "Cancel changes"}
                            </button>
                        </div>
                    </div>
                )}
            </article>
        </div>
    );
}

export default ImageUpdate;
